<template>

  <v-card fluid class="pa-0 recipient-email-editor d-flex flex-column">

    <!-- Title -->
    <v-card-title class="text-h6">
      {{ titleText }}
    </v-card-title>

    <v-card-text class="mt-2 flex-grow-1">

      <!-- Email address -->
      <v-row class="mt-1">
        <v-col cols="12">
          <v-text-field
              outlined
              label="Email address"
              hide-details="auto"
              v-model.trim="email" />
        </v-col>
      </v-row>

      <!-- Is Primary -->
      <v-row class="mt-1">
        <v-col cols="12">
          <v-switch
              label="Set as Primary?"
              class="pl-3"
              v-model="isPrimary" />
        </v-col>
      </v-row>

      <v-divider class="mt-4 mb-8" />

      <!-- Notification Settings -->
      <v-row class="mb-2">
        <v-col cols="12">
          <span class="section-title">Manage Notifications</span>
        </v-col>
      </v-row>
      <v-row no-gutters v-for="opt in notificationOptions" :key="opt.code">
        <v-col cols="12" class="pl-5 d-flex align-left justify-left">
          <v-checkbox
              :label="opt.label"
              v-model="notifications[opt.code]" />
          <v-tooltip right v-if="opt.tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="amber darken-3" class="pl-2" style="font-size:1.1rem" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
            </template>
            <div>{{ opt.tooltip }}</div>
          </v-tooltip>
        </v-col>
      </v-row>

    </v-card-text>

    <!-- Actions -->
    <v-card-actions class="mt-4 py-5 action-buttons">
      <v-btn
          plain
          color="primary"
          class="px-5"
          @click="cancel">
        Cancel
      </v-btn>
      <v-spacer />
      <v-btn
          color="primary"
          width="120"
          :disabled="!canSave"
          @click="save">
        {{ saveButtonText }}
      </v-btn>
    </v-card-actions>

  </v-card>

</template>

<script>
export default {
  name: 'RecipientEmailEditor',

  props: {
    recipientEmail: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      isNew: true,
      email: null,
      label: null,
      isPrimary: false,
      notifications: {
        credit_issued: true,
        submitted: true,
        scheduled: true,
        en_route: true,
        arrived: true,
        completed: true
      }
    }
  },

  computed: {
    notificationOptions () {
      return [
        { label: 'Credit issued', code: 'credit_issued' },
        { label: 'Order submitted / canceled', code: 'submitted' },
        { label: 'Order scheduled', code: 'scheduled', tooltip: 'Order scheduled or rescheduled' },
        { label: 'En route to location', code: 'en_route' },
        { label: 'Arrived at location', code: 'arrived' },
        { label: 'Order completed', code: 'completed', tooltip: 'Order rejected or delivered' }
      ]
    },
    titleText () {
      return (this.isNew) ? 'Add Email' : 'Edit Email'
    },
    saveButtonText () {
      return (this.isNew) ? 'Add Email' : 'Save'
    },
    canSave () {
      return this.email
    }
  },

  watch: {
    recipientEmail: function (recipientEmail) {
      if (recipientEmail) this.setRecipientEmail(recipientEmail)
      else this.reset()
    }
  },

  beforeMount () {
    if (this.recipientEmail) this.setRecipientEmail(this.recipientEmail)
  },

  beforeDestroy () {
    this.reset()
  },

  methods: {
    setRecipientEmail (recipientEmail = {}) {
      this.isNew = false
      this.email = recipientEmail.email
      this.label = recipientEmail.label
      this.isPrimary = recipientEmail.is_primary
      this.notifications = recipientEmail.settings
    },

    reset () {
      this.isNew = true
      this.email = null
      this.label = null
      this.isPrimary = false
      this.notifications = {
        credit_issued: true,
        submitted: true,
        scheduled: true,
        en_route: true,
        arrived: true,
        completed: true
      }
    },

    cancel () {
      this.reset()
      this.$emit('cancel')
    },

    save () {
      const data = {
        email: this.email,
        label: this.email,
        is_primary: this.isPrimary,
        settings: this.notifications
      }
      if (this.isNew) {
        this.$emit('create', data)
      } else {
        Object.assign(this.recipientEmail, data)
        this.$emit('update', this.recipientEmail)
      }
      this.reset()
    }
  }
}
</script>

<style scoped>
.recipient-email-editor {
  height: 100%;
}

.recipient-email-editor .section-title {
  color: #ffffff;
  font-weight: 500;
  font-size: 1.2rem;
}

.action-buttons {
  border-top: 1px solid #393939;
  background-color: #191919;
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
